import Tool, { type ITool } from "./Tool";
import CanvasUtils from "../utils/CanvasUtils";
import TextObject from "../objects/TextObject";

const MAX_TEXT_LENGTH = 200;

export type TextColors = typeof TEXT_COLORS;

export type TextColor = TextColors[number];

export type TextOptions = {
  fill: TextColor;
  fontSize: number;
  maxLength: number;
};

export const TEXT_COLORS = [
  "#1A2023",
  "#FFFFFF",
  "#EA5353",
  "#F7C647",
  "#2196F3",
  "#09B965",
  "#AB59E4",
] as const;

export const TEXT_DEFAULT_OPTIONS = {
  fill: TEXT_COLORS[1],
  fontSize: 20,
  maxLength: MAX_TEXT_LENGTH,
};

class TextTool extends Tool implements ITool<TextOptions> {
  private options: TextOptions = TEXT_DEFAULT_OPTIONS;

  activate(): void {
    if (!this.canvas) return;

    const fontSize = CanvasUtils.getFontSize(this.canvas);

    if (fontSize) {
      this.options.fontSize = fontSize;
    }

    CanvasUtils.updateCanvasCursor(this.canvas, "default");

    const text = new TextObject("Tap to add text", this.options);
    text.init(this.canvas);

    this.canvas.add(text);
    this.canvas.setActiveObject(text);
    this.canvas.bringObjectToFront(text);
    this.canvas.renderAll();
  }

  deactivate(): void {
    this.canvas = null;
  }

  updateOptions({ fill, fontSize, maxLength }: Partial<TextOptions>): void {
    if (fill) {
      this.options.fill = fill;
    }

    if (fontSize) {
      this.options.fontSize = fontSize;
    }

    if (maxLength) {
      this.options.maxLength = maxLength;
    }
  }
}

export default TextTool;
